import { style, trigger, transition, animate, state } from '@angular/animations';

const ANIMATION_DURATION_IN = 0.15;
const ANIMATION_DURATION_OUT = 0.15;
export const AnimationState = {
  hidden: 'hidden',
  visible: 'visible'
} as const;

export const enterLeaveAnimation = trigger('slideInOut', [
  state(
    AnimationState.hidden,
    style({
      transform: '{{hidden}}'
    }),
    { params: { hidden: 'translateX(-100%)' } }
  ),
  state(
    AnimationState.visible,
    style({
      transform: '{{visible}}'
    }),
    { params: { visible: 'translateX(0%)' } }
  ),
  transition('visible => hidden', animate(`${ANIMATION_DURATION_OUT}s ease-in-out`)),
  transition('void => *', [style({ transform: '{{hidden}}' }), animate(`${ANIMATION_DURATION_IN}s ease-in-out`)])
]);
